// @martyrs/src/modules/core/locales/en.js
export default {
  core: {
    ui: {
      darkMode: 'Dark Mode',
      // Close button of the popup header (PopupHeader).
      popupClose: 'Close',
      // Calendar of the design system.
      back: 'Back',
      previousMonth: 'Previous month',
      nextMonth: 'Next month',
    },
    errors: {
      USER_NOT_FOUND: 'Such user is not registered',
      USER_ALREADY_REGISTERED: 'Such user is already registered!',
      USER_NOT_REGISTERED_YET: 'This user has not been registered yet!',
      USER_PHONE_OR_PASSWORD_NOT_FOUND: 'User with such phone or password not found!',
      INCORRECT_PASSWORD_ENTERED: 'You entered an incorrect password!',
      AUTH_METHOD_DISABLED: 'This sign-in method is disabled.',
      INVALID_INVITATION_CODE: 'Incorrect invitation code.',
      MISSING_REQUIRED_PARAMETERS: 'Missing required parameters.',
      ERROR_UPDATING_USER: 'Something wrong when updating user.',
      PASSWORDS_DO_NOT_MATCH: 'The passwords you entered do not match. Please correct the errors and try again.',
      CODE_NOT_SENT: 'Something went wrong and the code was not sent. Please try again.',
      INPUT_ERROR: 'Please enter only a four-digit code.',
      WRONG_CODE: 'You entered an incorrect code. Please try again.',
      POST_URL_ALREADY_IN_USE: 'Failed! Blogpost with this URL is already in use!',
      NAME_CANNOT_BE_EMPTY: 'Error: Name cannot be empty. Please enter a name.',
      INVALID_LOCALE: 'This language is not supported.',
      INVALID_COUNTRY: 'There is no such country in the directory.',
      COUNTRY_CHANGE_LIMIT: 'Country can be changed once every 30 days',
      // File upload errors
      NO_FILES_UPLOADED: 'No files were uploaded.',
      FILE_PROCESSING_ERROR: 'Error processing files. Please try again.',
      FILES_TOO_LARGE: 'One or more files exceed the size limit.',
      FILES_WRONG_TYPE: 'One or more files have unsupported format.',
      FILES_SIZE_AND_TYPE_ERROR: 'Some files are too large and have unsupported format.',
      PREVIEW_GENERATION_ERROR: 'Error generating file previews.',
      IMAGE_CONVERSION_ERROR: 'Error converting image format.'
    },
    timeAgo: {
      now: 'Just now',
      minute: '{n} min ago',
      hour: '{n} h ago',
      day: '{n} d ago',
      week: '{n} w ago',
    }
  },
  footer: {
    description: 'Get in touch with us',
    phoneNumber: '+1 234 567 890',
    emailAddress: "info{'@'}example.com",
    hours_text: 'Mon-Fri: 9:00 AM - 6:00 PM',
    app: 'Download our app',
    subscribe: 'Subscribe to our newsletter',
    subscribe_text: 'Stay updated with the latest news and updates',
    follow: 'Follow us',
    year: '2025',
    heart: '♥',
    copyright: 'All rights reserved',
    ozdao: 'Made by OZ DAO',
    navigationColumns: [
      {
        sections: [
          {
            title: 'Company',
            items: [
              { name: 'About', url: 'about' },
              { name: 'Careers', url: 'careers' },
              { name: 'Contact', url: 'contact' }
            ]
          }
        ]
      },
      {
        sections: [
          {
            title: 'Resources',
            items: [
              { name: 'Blog', url: 'blog' },
              { name: 'Help Center', url: 'help' },
              { name: 'Privacy', url: 'privacy' }
            ]
          }
        ]
      }
    ],
    socialLinks: [
      { name: 'instagram', url: 'https://instagram.com' },
      { name: 'facebook', url: 'https://facebook.com' },
      { name: 'linkedin', url: 'https://linkedin.com' }
    ]
  }
};